import qs from 'qs';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { WelcomeModal } from '@hero/components/modals';
import { configs } from '@hero/configs';
import { BannerSlider, HomeTopCategories } from '@hero/organisms';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetCSEntries } from '@hero/services/content-stack-service/hooks';
import { useGetUser, useUpdateUser } from '@hero/services/organization-service/hooks';

import { Category } from './Components';
import * as S from './style';

function HomeTemplate() {
  const navigate = useNavigate();

  const { data: userData } = useGetUser();
  const { mutateAsync: onUserUpdate } = useUpdateUser({
    invalidate: false
  });

  const { data: homeBanners } = useGetCSEntries({
    entryCode: 'sgb_admin_home_banners'
  });

  const { data: categoryProducts } = useGetCSEntries({
    entryCode: 'sgb_admin_home_promoted_categories'
  });

  const banners = homeBanners?.entries?.sort((a, b) => a.order - b.order);

  const sortedCategoryProductSlider = categoryProducts?.entries?.sort((a, b) => a.order - b.order);

  useEffect(() => {
    if (!configs.homePage.enabled) {
      navigate(ROUTE_PATHS.DASHBOARD, { replace: true });
    }
  }, []);

  const showWelcomeModal =
    !userData?.meta?.isWelcomeModalOpened && configs.homePage.showWelcomeModal;

  useEffect(() => {
    if (showWelcomeModal) {
      onUserUpdate({ meta: { isWelcomeModalOpened: true } });
    }
  }, [showWelcomeModal]);

  return (
    <S.HomeTemplate>
      <BannerSlider banners={banners} />
      {showWelcomeModal && <WelcomeModal />}
      <S.Content>
        <HomeTopCategories />
        <S.Categories>
          {sortedCategoryProductSlider?.map(entity => (
            <Category
              key={entity.name}
              title={entity.name}
              onSeeAll={() => {
                let queryString = {};
                if (entity?.entity_type?.toLowerCase() === 'collection') {
                  queryString = {
                    collectionIds: [entity.entity_id]
                  };
                } else {
                  queryString = {
                    categoryIds: [entity.entity_id] // TODO: Remove categoryId after updating PROD data
                  };
                }
                const search = qs.stringify(queryString);
                navigate(`${ROUTE_PATHS.GIFT_CATALOG}?${search}`);
              }}
              data={entity}
            />
          ))}
        </S.Categories>
      </S.Content>
    </S.HomeTemplate>
  );
}

export { HomeTemplate };
